export default __webpack_public_path__ + "static/media/ig3.670188cf.jpg";